/**
 * Ground News - Bias Checker — media-bias overlay
 *
 * Declares two web-accessible-resource entries, both matched to http(s) origins
 * (every origin) with no `use_dynamic_url`. The first holds static UI files
 * (`frame.html`, `popup.html`, `js/popup.js`); the second exposes the bundled
 * `fonts/*.woff` and `fonts/*.ttf`. All are reachable from any page at a fixed
 * URL, so a single fetch is conclusive — the resource is served only if the
 * extension is installed and the ID is in the URL.
 *
 * Manifest verified against version 3.2.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'agleiimpggapjekcdhdjbmegjbbkleie';

export const groundNews: ExtensionDefinition = {
  id: ID,
  name: 'Ground News - Bias Checker',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 40_000,
  notes:
    'Static WAR (frame.html, js/popup.js, UniversalSans fonts) on every origin with no ' +
    'dynamic URL. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-frame-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch frame.html — the injected-overlay entry point, exposed to every origin ' +
        'at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'frame.html'),
    },
    {
      id: 'war-popup-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/popup.js — a second static path, independent of frame.html.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/popup.js'),
    },
    {
      id: 'war-universal-sans-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch fonts/UniversalSans-480.woff — a vendor-named bundled font, corroborating ' +
        'via the second WAR entry.',
      weight: 0.5,
      run: () => probeFetch(ID, 'fonts/UniversalSans-480.woff'),
    },
  ],
};
